import {createSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {initialState} from './reducer';

const select = (state: Store) => state.drivers || initialState;

const makeSelectDriversList = () =>
  createSelector(select, substate => substate.driversList);

const makeSelectDriversWalletList = () =>
  createSelector(select, substate => substate.driversWalletList);

const makeSelectDriversWalletTransactionList = () =>
  createSelector(select, substate => substate.driversWalletTransactionList);

const makeSelectDriversWalletBulkTransaction = () =>
  createSelector(select, substate => substate.driversWalletBulkTransaction);

const makeSelectDriversWalletBulkTransactionResult = () =>
  createSelector(select, substate => substate.driversWalletBulkTransactionResult);

const makeSelectDriver = () =>
  createSelector(select, substate => substate.driver);

const makeSelectCentersList = () =>
  createSelector(select, substate => substate.centersList);

const makeSelectPreferredSources = () =>
  createSelector(select, substate => substate.preferredSources);

const makeSelectDriverShifts = () =>
  createSelector(select, substate => substate.driverShifts);

const makeSelectDriverShiftsLoading = () =>
  createSelector(select, substate => substate.driverShiftsLoading);

const makeSelectCountList = () =>
  createSelector(select, substate => substate.count);

const makeSelectWalletTransactionCountList = () =>
  createSelector(select, substate => substate.driversWalletTransactionCount);

const makeSelectSumWallet = () =>
  createSelector(select, substate => substate.sumWallet);

const makeSelectActiveCountList = () =>
  createSelector(select, substate => substate.activeCount);

const makeSelectDeactiveCountList = () =>
  createSelector(select, substate => substate.deactiveCount);

const makeSelectLoading = () =>
  createSelector(select, substate => substate.loading);

const makeSelectPreferredSourcesLoading = () =>
  createSelector(select, substate => substate.preferredSourcesLoading);

const makeSelectError = () =>
  createSelector(select, substate => substate.error);

export default select;
export {
  makeSelectDriversList,
  makeSelectDriversWalletList,
  makeSelectCentersList,
  makeSelectLoading,
  makeSelectCountList,
  makeSelectSumWallet,
  makeSelectPreferredSources,
  makeSelectPreferredSourcesLoading,
  makeSelectDriverShifts,
  makeSelectDriverShiftsLoading,
  makeSelectError,
  makeSelectActiveCountList,
  makeSelectDeactiveCountList,
  makeSelectDriver,
  makeSelectDriversWalletTransactionList,
  makeSelectWalletTransactionCountList,
  makeSelectDriversWalletBulkTransaction,
  makeSelectDriversWalletBulkTransactionResult,
};
